import { Ref } from 'preact';
import styled from 'styled-components';

export const Container = styled.div<{
  ref: Ref<HTMLDivElement>;
  cardHeight: number;
}>`
  width: 232px;
  height: ${({ cardHeight }) => cardHeight - 4}px;
  transition: height 0.4s;
  &:hover,
  &[aria-pressed='true'] {
    height: ${({ cardHeight }) => cardHeight + 24}px;
  }
`;
